import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Wallet } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { FundsInTransitIcon } from 'ah-common-lib/src/icons/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletInfoTitle',
  props: {
    wallet: null,
    titleTag: { default: 'h2' },
    titleClass: { default: '' },
    subTitleTag: { default: 'p' },
    subTitleClass: { default: 'text-secondary mt-n3' }
  },
  setup(__props: any) {

const props = __props as { wallet: Wallet, titleTag: string, titleClass: string, subTitleTag: string, subTitleClass: string };



const sellTransit = computed(
  () => ` ${props.wallet.currency} ${formatCurrencyValue(props.wallet.tradeSellAmountInTransit)}`
);
const buyTransit = computed(
  () => ` ${props.wallet.currency} ${formatCurrencyValue(props.wallet.tradeBuyAmountInTransit)}`
);

return { __sfc: true,props, sellTransit, buyTransit, formatCurrencyValue, FundsInTransitIcon }
}

})